/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import ITiposBodegas from 'Infotrack@Modelos/smartStock/tiposBodegas/entidades/tiposBodegas';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import TiposBodegasCM from '../controladorModelo/tiposBodegasCM';
import { IFormularioTiposBodegasCVProps } from '../interfaces';
import { acciones, IEstadoTiposBodegas } from '../reductorTiposBodegas';
import FormularioTiposBodegasVista from '../vista/formularioTiposBodegasVista';
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import { useSelector } from 'react-redux';
const estadoInicial: ITiposBodegas = {
    EmpresaId: '',
    TipoBodegaDescripcion: '',
    Estado: 1,
    AgenciaId: '',
};
const tiposBodegasCM = new TiposBodegasCM();

const FormularioTiposBodegasCV: React.FunctionComponent<IFormularioTiposBodegasCVProps> = ({ IdEmpresa }) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual!.IdAgencia);
    const [{ estadoFormulario, tipoFormulario, entidadTiposBodegas }, dispatch] = useProveedor<IEstadoTiposBodegas>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<ITiposBodegas>(estadoInicial);

    React.useEffect(() => {
        if (entidadTiposBodegas && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadTiposBodegas);
        } else {
            reiniciar();
        }
    }, [entidadTiposBodegas]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionTiposBodegas = () => {
        if (tiposBodegasCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarTiposBodegas,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarTiposBodegas = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            tiposBodegasCM
                .crearTiposBodegas({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        } else {
            tiposBodegasCM
                .editarTiposBodegas({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        }
    };

    return (
        <FormularioTiposBodegasVista
            accionCrearEditar={confirmarCreacionEdicionTiposBodegas}
            cambiarInfoFomulario={alCambiarValor}
            tiposBodegas={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioTiposBodegasCVProps => ({
    IdEmpresa: usuarioInformacion!.IdEmpresa,
});

export default connect<IFormularioTiposBodegasCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioTiposBodegasCV);
